var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 18,
    height: 18,
    transform: "translate(60 171)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_29",
    "data-name": "Mask Group 29",
    transform: "translate(-60 -171)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(58.714 169.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M7.181,3.857l2.2,2.192.373.379H18V16.714H2.571V3.857H7.181m0-1.286H2.571A1.286,1.286,0,0,0,1.286,3.857V16.714A1.286,1.286,0,0,0,2.571,18H18a1.286,1.286,0,0,0,1.286-1.286V6.429A1.286,1.286,0,0,0,18,5.143H10.286L8.094,2.951A1.286,1.286,0,0,0,7.181,2.571Z",
    fill: "#9babc5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.99723fa11fe6c00077b1d218230f0a06.svg";
export { ForwardRef as ReactComponent };